import styled from "styled-components/macro";

export const TextoAlerta = styled.p(({ theme }) => ({
  margin: "0 !important",
  color: theme.color.line.light,
}));

export default styled.div(({ theme }) => ({
  marginTop: "20px",
  backgroundColor: `${theme.color.brandPrimary.dark} !important`,

  '[class^="AlertStyle__AlertaIcon-sc"]': {
    color: theme.color.line.light,
  },
}));
